import moment from 'moment-timezone';
import { forceToMonFri } from '../components/DateFunction';

// ------------------------------------
// Constants
// ------------------------------------
export const CHANGE_YEAR = 'CHANGE_YEAR';

export const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
export const CHANGE_FLIGHT_MODAL = 'CHANGE_FLIGHT_MODAL';
export const CHANGE_DATE_FROM = 'CHANGE_DATE_FROM';
export const CHANGE_DATE_TO = 'CHANGE_DATE_TO';
export const CHANGE_VISIT_MODAL = 'CHANGE_VISIT_MODAL';
export const TOGGLE_SEGEMENT = 'TOGGLE_SEGEMENT';
export const SEARCH_ROOM = 'SEARCH_ROOM';


// ------------------------------------
// Reducer
// ------------------------------------

let date = new Date();
let dateTo = moment().add(28, 'days');


date = forceToMonFri(moment().format('YYYY-MM-DD'));
dateTo = forceToMonFri(dateTo.format('YYYY-MM-DD'));

const initialState = {
    year: 2016,
    flightModal: false,
    flightInfo: 'No Flight Info',
    dateFrom: moment(date).format('YYYY-MM-DD'),
    visitModal: false,
    dateTo: moment(dateTo).format('YYYY-MM-DD'),
    visitId: '',
    toggleSegmentStatus: false,
    roomData: [],
    flightData: [],
};


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [CHANGE_YEAR]: (state, action) => Object.assign({}, state, {
        year: action.payload,
    }),
    [CHANGE_FLIGHT_MODAL]: (state, action) => Object.assign({}, state, {
        flightModal: action.payload.modal,
        flightInfo: action.payload.flightInfo,
    }),
    [CHANGE_DATE_TO]: (state, action) => Object.assign({}, state, {
        dateTo: action.payload,
    }),
    [CHANGE_DATE_FROM]: (state, action) => Object.assign({}, state, {
        dateFrom: action.payload,
    }),
    [CHANGE_VISIT_MODAL]: (state, action) => Object.assign({}, state, {
        visitModal: action.payload.modal,
        visitId: action.payload.visitId,
    }),
    [TOGGLE_SEGEMENT]: (state, action) => Object.assign({}, state, {
        toggleSegmentStatus: action.payload,
    }),
    [SEARCH_ROOM]: (state, action) => Object.assign({}, state, {

    }),
};


export default function counterReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];

    return handler ? handler(state, action) : state;
}